import React from 'react';
import { Activity, Target, Home, Dumbbell } from 'lucide-react';

export const Solution = () => {
  const features = [
    {
      icon: <Activity size={32} />,
      title: 'Physiotherapeutischer Ansatz',
      description: 'Basierend auf wissenschaftlichen Erkenntnissen und jahrelanger Erfahrung.'
    },
    {
      icon: <Target size={32} />,
      title: 'Funktionelles Training',
      description: 'Keine isolierten Übungen – trainiere Bewegungen, die dein Leben verbessern.'
    },
    {
      icon: <Home size={32} />,
      title: 'Flexibel & ortsunabhängig',
      description: '3× pro Woche, 30 Minuten – zu Hause oder im Büro.'
    },
    {
      icon: <Dumbbell size={32} />,
      title: 'Minimale Ausrüstung',
      description: 'Nur Bänder, Kettlebell oder Kurzhantel und eine Matte – keine teuren Geräte nötig.'
    }
  ];

  return (
    <section id="losung" style={{
      padding: 'var(--spacing-giant) 0'
    }}>
      <div className="container">
        <div style={{ textAlign: 'center', marginBottom: 'var(--spacing-xl)' }}>
          <h2 className="display-medium" style={{ marginBottom: 'var(--spacing-medium)' }}>
            Die Lösung: Haltung-Reset
          </h2>
          <p className="body-large" style={{ maxWidth: '700px', margin: '0 auto' }}>
            Ein 12-Wochen-Programm, das deine Bewegungsmuster von Grund auf neu aufbaut – individuell angepasst auf deine Bedürfnisse.
          </p>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
          gap: 'var(--spacing-large)'
        }}>
          {features.map((feature, index) => (
            <div key={index} className="network-card" style={{
              textAlign: 'center',
              cursor: 'default'
            }}>
              <div style={{
                color: 'var(--brand-dark)',
                marginBottom: 'var(--spacing-medium)',
                display: 'flex',
                justifyContent: 'center'
              }}>
                {feature.icon}
              </div>
              <h3 className="heading-3" style={{ marginBottom: 'var(--spacing-small)' }}>
                {feature.title}
              </h3>
              <p className="body-medium">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};